import React, { Component } from "react";
import { AppBar } from '@mui/material';
import withStyles from "@material-ui/core/styles/withStyles";
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { HashLink as Link } from 'react-router-hash-link';
import Order from "./Order";

const styles = theme => ({
  bar: {
    [theme.breakpoints.up("md")]: {
      display: "none !important"
    },
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    gap: 8,
    height: 64,
    padding: "0 12px",
  },
  orderBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    minHeight: 44,
    padding: "0 22px",
    border: 0,
    borderRadius: "3em",
    backgroundColor: "#212529",
    color: "#fff",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    "&:focus-visible": {
      outline: "3px solid #fff",
      outlineOffset: 2
    }
  },
  locationLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    minHeight: 44,
    padding: "0 12px",
    color: "#000",
    fontWeight: 600,
    "&:hover, &:focus": {
      color: "#000"
    }
  }
})

class BottomBar extends Component {
  state = {
    modalOpen: false
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <AppBar
          component="nav"
          aria-label="Quick actions"
          position="fixed"
          className={classes.bar}
          sx={{ top: 'auto', bottom: 0, backgroundColor: "rgba(220,159,57,0.95)", paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <div className={classes.inner}>
            <button
              type="button"
              onClick={() => this.setState({ modalOpen: true })}
              className={classes.orderBtn}
              aria-haspopup="dialog"
            >
              <StorefrontIcon fontSize="small" aria-hidden="true" /> Order Now
            </button>
            <Link
              to={{
                  pathname: "/",
                  hash: "location-hours"
                }}
              className={classes.locationLink}
            >
              <LocationOnIcon aria-hidden="true" /> Location
            </Link>
          </div>
        </AppBar>
        <Order modalOpen={this.state.modalOpen} handleClose={() => this.setState({ modalOpen: false })}/>
      </>
    )
  }
}

export default withStyles(styles)(BottomBar);
